import script from "./StockSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./StockSummary.vue?vue&type=script&setup=true&lang=js"

import "./StockSummary.vue?vue&type=style&index=0&id=704c4b17&scoped=true&lang=scss"
import "./StockSummary.vue?vue&type=style&index=1&id=704c4b17&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-704c4b17"]])

export default __exports__